import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const BASE = `${String(url).replace(/\/+$/, "")}/api/commissions`;

async function request(path, options = {}) {
  const endpoint = `${BASE}${path}`;
  const response = await fetchWithAuth(endpoint, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || `Request failed ${response.status}`);
  }
  return response.json();
}

export const commissionsApi = {
  list: (params = {}) => {
    const sp = new URLSearchParams();
    if (params.active !== undefined) sp.set("active", String(params.active));
    if (params.search) sp.set("search", params.search);
    const qs = sp.toString();
    return request(qs ? `?${qs}` : "");
  },
  getById: (id) => request(`/${id}`),
  create: (payload) => request("", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) => request(`/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  delete: (id) => request(`/${id}`, { method: "DELETE" }),
  assignments: (structureId) => request(`/${structureId}/assignments`),
  assignUser: (structureId, userId) =>
    request(`/${structureId}/assignments`, {
      method: "POST",
      body: JSON.stringify({ user_id: userId }),
    }),
  removeAssignment: (structureId, userId) =>
    request(`/${structureId}/assignments/${userId}`, { method: "DELETE" }),
  records: (structureId, params = {}) => {
    const sp = new URLSearchParams();
    if (params.user_id != null) sp.set("user_id", params.user_id);
    if (params.status) sp.set("status", params.status);
    const qs = sp.toString();
    return request(`/${structureId}/records${qs ? `?${qs}` : ""}`);
  },
  updateRecordStatus: (structureId, recordId, status) =>
    request(`/${structureId}/records/${recordId}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
    }),
  analytics: (structureId) => request(`/${structureId}/analytics`),
  my: () => request("/my"),
  employees: () => request("/employees"),
  constants: () => request("/constants"),
};
